// src/platform/PlatformLogin.js — superadmin login (multi-tenant control panel)
import React, { useState } from 'react';
import { platformLogin } from '../utils/api';

export default function PlatformLogin({ onLoggedIn }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const r = await platformLogin(email, password);
      localStorage.setItem('bc_platform_token', r.data.token);
      onLoggedIn(r.data.admin);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div style={{ marginBottom: 28, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 700 }}><span className="logo-dot" />Platform Admin</div>
          <div style={{ fontSize: 13, color: 'var(--gray-400)', marginTop: 4 }}>Sign in to manage tenants</div>
        </div>
        <form onSubmit={submit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" autoFocus required />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>
          {error && <p className="error-text" style={{ marginBottom: 10 }}>{error}</p>}
          <button className="btn btn-primary" style={{ width: '100%', marginTop: 4, justifyContent: 'center' }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
